import { Injectable } from '@angular/core';
import { IUserInfo,LoginData } from './../../common/interfaces/user-login.interface';
import axios, {AxiosResponse}  from 'axios';
import { environment, BASE_URL_SERVICIOS_LOGIN } from "@env/environment";
import { TokenSsoRequest } from 'src/app/common/interfaces/tokenssorequest.interface';
import Utils from '@utils/utils';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
       
  public async loginWithLocal(usuario: LoginData): Promise<IUserInfo> {
    const BASE_URL =  BASE_URL_SERVICIOS_LOGIN + '/multi-login/loginWithLocal';
    try {
      usuario.idSistema = environment.idSistema;
      const response: AxiosResponse<IUserInfo> = await axios.post(BASE_URL, usuario, {
      headers: {
        'apiKey': environment.apiKeyCargaUsuarios,
      },
    });
      const dataUsuario = JSON.stringify(response.data);
      sessionStorage.setItem('USUARIO', dataUsuario);
      return response.data;
    } catch (error) {
      let rs : IUserInfo = {} as IUserInfo;
      return rs;
    }
  }

  public async loginWithGesdep(usuario: LoginData): Promise<IUserInfo> {
    const BASE_URL =  BASE_URL_SERVICIOS_LOGIN + '/multi-login/loginWithGesdep';
    try {
      usuario.idSistema = environment.idSistema;
      const response: AxiosResponse<IUserInfo> = await axios.post(BASE_URL, usuario, {
      headers: {
        'apiKey': environment.apiKeyCargaUsuarios,
      },
    });
      const dataUsuario = JSON.stringify(response.data);
      sessionStorage.setItem('USUARIO', dataUsuario);
      return response.data;
    } catch (error) {
      let rs : IUserInfo = {} as IUserInfo;
      return rs;
    }
  }

  public getUserInfo() : IUserInfo {
    let respuesta = {} as IUserInfo;
    const userInfo = sessionStorage.getItem('USUARIO');
    if(userInfo != null) {
      respuesta = JSON.parse(userInfo) as IUserInfo;
    }    
    return respuesta;
  }

  public async validateSession(): Promise<boolean> {
    const userInfo = sessionStorage.getItem('USUARIO');
    if(userInfo != null) {
      const UserInfoObj = this.getUserInfo();
      return await this.validateJwt(UserInfoObj.jwt);
    } else {
      return false;
    }
  }

  public async validateLocalSession(): Promise<boolean> {
    const userInfo = sessionStorage.getItem('USUARIO');
    if(userInfo != null) {
      return true;
    } else {
      return false;
    }
  }

  public async validateJwt(jwt: any): Promise<boolean> {
    const BASE_URL =  BASE_URL_SERVICIOS_LOGIN + '/multi-login/validaJwt';
    return await axios.post(BASE_URL, {} ,{
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    }).then(resp => {    
      return resp.data; 
    }).catch(() => {
      sessionStorage.clear();
      return false;
    }); 
  }  

  public signOut() {
    let loginSso = localStorage.getItem('LOGINGSSO');
    const userInfo = this.getUserInfo();
    let logoutUrl: string = '';
    if (loginSso == '1') {
      const codeState = Utils.generateStringCode();
      const hashState = Utils.generateHashState(codeState);
      logoutUrl = Utils.getAuthorizerLogoutUrl(hashState, userInfo.token)
    }
    
    sessionStorage.clear();

    if (loginSso == '1') {
      window.location.href = logoutUrl;
    } else {
      window.location.href = '/';
    }
  }
 
  public async signInWithCode(tokenSsoRequest: TokenSsoRequest): Promise<IUserInfo> {
    const BASE_URL =  BASE_URL_SERVICIOS_LOGIN + '/multi-login/getDatosUsuarioSSO';
    try {
      const response: AxiosResponse<IUserInfo> = await axios.post(BASE_URL, tokenSsoRequest, {
      headers: {
        'apiKey': environment.apiKeyCargaUsuarios,
      },
    });
      const dataUsuario = JSON.stringify(response.data);
      sessionStorage.setItem('USUARIO', dataUsuario);
      return response.data;
    } catch (error) {
      let rs : IUserInfo = {} as IUserInfo;
      return rs;
    }
  }
}